import React from "react";
import { useExtLabels } from './extLabels'

const version = '1.1.0'

const Footer = ({ subject }) => {
    const l = useExtLabels()

  const link = `mailto:biuro@mobileinstitute.eu?subject=${subject}`
  
  return (
        <footer>
            <div style={{ display: "inline-block", float: "left", paddingTop: "1rem" }}>
                Powered by{" "}
                <a href="https://www.mobileinstitute.eu" target="_blank" rel="noopener noreferrer">
                    Mobile Institute
                </a>
                <span>, ver.{version}</span>
            </div>
            <div style={{ display: "inline-block", float: "right", paddingTop: "1rem" }}>
                <a href={link}>{l('Zgłoś problem')}</a>
            </div>
        </footer>
    );
};

export default Footer;
